/**
 * Раскладка и шорткаты.
 *
 * `event.key` — это символ, который клавиша печатает В ТЕКУЩЕЙ РАСКЛАДКЕ: при
 * русской физическая `E` даёт `у`, `S` даёт `ы`, `/` даёт `.`. Сопоставлять
 * аккорды по нему значит требовать переключения раскладки перед каждой командой —
 * в интерфейсе, где алфавит и есть система команд, это неприемлемо.
 */

/** Физическая клавиша (QWERTY-позиция) → символ, который на ней написан. */
const CODE_CHAR: Record<string, string> = (() => {
	const map: Record<string, string> = { Slash: "/" };
	for (let i = 0; i < 26; i++) {
		const letter = String.fromCharCode(97 + i);
		map[`Key${letter.toUpperCase()}`] = letter;
	}
	for (let d = 0; d <= 9; d++) {
		map[`Digit${d}`] = String(d);
		map[`Numpad${d}`] = String(d);
	}
	return map;
})();

/**
 * Символ клавиши для шорткатов, не зависящий от раскладки.
 *
 * Латиница и цифры берутся из самого `key` — так шорткаты продолжают уважать
 * нестандартные латинские раскладки (Dvorak, AZERTY), где физические позиции
 * другие. Всё остальное (кириллица и прочее не-латинское) разбирается по
 * физической позиции `code`, то есть по тому, что на этой клавише написано
 * в QWERTY.
 *
 * Прочая пунктуация не мапится сознательно: в шорткатах участвует только `/`,
 * а остальные клавиши (`ж`, `э`, `х`, `ъ`, `ё` на русской) не делают ничего
 * и в английской раскладке тоже.
 *
 * Возвращает `null`, если нажатое к шорткатам отношения не имеет — включая
 * пустой `code` у синтетических событий и экранных клавиатур.
 */
export function shortcutChar(event: KeyboardEvent): string | null {
	if (event.isComposing) {
		return null; // IME набирает слово — это ввод текста, а не команда
	}
	const key = event.key;
	if (key.length === 1 && (/[a-z0-9]/i.test(key) || key === "/")) {
		return key.toLowerCase();
	}
	return CODE_CHAR[event.code] ?? null;
}
